// Green Gorilla Fruits — common theme JS
// M1 placeholder. Section-level scripts (cart-drawer, plan-selector, etc.)
// will be added in M2/M3 and loaded only on pages that need them.

(function () {
  'use strict';

  // Mark <html> with `js` so CSS can target the JS-enabled state if needed.
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
})();
